import FBImages from "./FBImages";
import SNAlbumsCell from "./SNAlbumsCell";
import SNAlbumMessage from "./SNAlbumMessage";
import FBLoginBtn from "./FBLoginBtn";
import IGImages from "./IGImages";
import IGLoginBtn from "./IGLoginBtn";
import ImageCell from "./ImageCell";
import ImagePagination from "./ImagePagination";
import SNHeader from "./SNHeader";

export default {
  FBImages,
  SNAlbumsCell,
  SNAlbumMessage,
  FBLoginBtn,
  IGImages,
  IGLoginBtn,
  ImageCell,
  ImagePagination,
  SNHeader,
};
